// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import $ from 'jquery';



import {  
    UtilService, populateProductSpace,
    getURLParameter, loadsearchData
    //,encodeSpaceVersionKey
} from './models/UtilService';

//import Papa from 'papaparse'; 
import { ViewportScrollInformations,ViewPortModus, Language, ProductSection, SpaceProperty } from './models/ProductModels';
import detectBrowserLanguage from 'detect-browser-language';
import { Log, ILogger } from './models/Logger';
import { Viewport, ProductViewport, EmptyViewport, PartProductOverviewport, IndexViewport, getSpaceContentProperties } from './models/Viewport';
import SearchComponent from './components/SearchComponent.vue';
import LangDropdown from './components/LangDropdown.vue';
import Modal from './components/customs-components/Modal.vue';
import Tabs from './components/customs-components/Tabs.vue';
import Message from './components/customs-components/Message.vue';
import Tab from './components/customs-components/Tab.vue';
import ProductSectionComponent from './components/index-viewport-components/ProductSectionComponent.vue';
import ProductSubsectionComponent from './components/index-viewport-components/ProductSubsectionComponent.vue';
import ProductAlphabeticalComponent from './components/index-viewport-components/ProductAlphabeticalComponent.vue';
import VersionSelectDropdown from './components/product-viewport-components/VersionSelectDropdown.vue';
import PartProductVersionSelectDropdown from './components/partproduct-viewport-components/PartProductVersionSelectDropdown.vue';
import PartProductContent from './components/partproduct-viewport-components/PartProductContent.vue';
import TreeItem from './components/left-navigation/TreeItem.vue';
import RootEl from "./apps/test/RootEl.vue";
import Multipane from './apps/test_resizable_boxes/resizable_components/Multipane.vue'
import MultipaneResizer from './apps/test_resizable_boxes/resizable_components/MultipaneResizer.vue'
import { resolve } from 'path';
import ProductServicePackComponent from './components/index-viewport-components/ProductServicePackComponent';
//import { Config } from './models/ViewportConfig';

 
Vue.config.productionTip = false

declare var isIndex: boolean;
declare var prodName: string;
declare var language: string;
declare var spaceName: string;
declare var spaceKey: string;
declare var themeUrl: string;
declare var isPartProdOverview: boolean;
declare var contextPath:string;
declare var isSearch:boolean;
declare var searchType:string;
declare var searchTerm:string;
declare var isEmptyView:boolean;
declare var viewportLink:string;

/*
console.log('SPACEKEY WE GOT: ' + spaceKey);
console.log('IS_INDEX WE GOT: ' + isIndex);
console.log('THEME WE GOT: ' + themeUrl);
console.log('SPACE_NAME WE GOT: ' + spaceName);
console.log('IS_INDEX WE GOT: ' + isPartProdOverview);
*/


var Logger = new Log();
var LOG_ENABLED: boolean =process.env.VUE_APP_LOG_ENABLE=='true';
var DEBUG_ENABLED: boolean =process.env.VUE_APP_DEBUG_ENABLE=='true';

var TEMPLATE_PRODUCT_VIEWPORT = process.env.VUE_APP_TEMPLATE_PRODUCT_VIEWPORT;
var TEMPLATE_INDEX_VIEWPORT = process.env.VUE_APP_TEMPLATE_INDEX_VIEWPORT;

var INDEX_PAGE_DE = process.env.VUE_APP_INDEX_PAGE_NAME_DE;
var INDEX_PAGE_EN = process.env.VUE_APP_INDEX_PAGE_NAME_EN;


var contentCenterData;
var languageDrop;

function moveInDocumentStyles(){
    //console.log('????????????????????????????????');
    let replaceableBlock:Element = document.querySelector('div#replaceable-template-block');
   
     //console.dir(replaceableBlock);

    if(replaceableBlock){
     let inDocStyleTags:any = replaceableBlock.querySelectorAll('style');
     //console.dir(inDocStyleTags);

     let movedStylesText=[]; 
     let movedStyle = document.createElement('style');
     movedStyle.setAttribute('id', 'movedStyles');
     movedStyle.type = "text/css";

     inDocStyleTags.forEach(element => {
        //movedStylesText.push(element.textContent); 
        movedStyle.textContent = movedStyle.textContent+'\n'+element.textContent;
        element.remove();
     });
     
     document.head.appendChild(movedStyle);
    
    // console.log(movedStyle.textContent);
    }
    else{
     console.log('No innerStyle Tags found');
    }
}

Logger.info('Starting App...');
console.log("Starting Infos for Url: "+process.env.VUE_APP_BASE_URL);


//Make sure to have the language set to Default DE if empty
language = language?language:'DE';


//Detect Browser information of the User then redirect to the right index Page
var browserLanguage = detectBrowserLanguage();

//console.log("ViewportLink", viewportLink);
//console.log("Winlocation", window.location);
//console.log("BrowserLanguage", browserLanguage);



//Check if the User is accessing the /index Page then determine the language
if(viewportLink && viewportLink==="/index" || window.location.pathname==="/index"){
    if(browserLanguage){
        console.log('Outside the Loop Loop: ',browserLanguage.toLowerCase());
        if(browserLanguage.toLowerCase()!=='de' && !browserLanguage.toLowerCase().startsWith('de')){
            
           // console.log('to_lower_bool:',browserLanguage.toLowerCase()!=='de');
           // console.log('In the Loop: ',browserLanguage.toLowerCase());
           // console.log('topic',!browserLanguage.toLowerCase().startsWith('de-'));
           // console.log('topic',browserLanguage.toLowerCase().startsWith('de-'));
    
            window.location.href=process.env.VUE_APP_BASE_URL+"/index_en";
        }
    }
}


/*
if(browserLanguage&& (browserLanguage.toLowerCase==='de' || browserLanguage.startsWith('de-')))
{
   if(language!=='DE')
   {
       window.location.href="http://www.google.de";
   } 
}
else{
    if()
}


*/



var lang: Language = Language[language];

//console.log('LANGUAGE: ', language);
//console.log('LANGUAGE-ENUM: ', lang);


var viewportScrollInformations:ViewportScrollInformations = 
{
    language: lang,
    themeUrl:themeUrl,
    spaceKey:spaceKey,
    prodName:prodName,
    contextPath:contextPath,  
    spaceName:spaceName, 
    isIndex: isIndex,
    isSearch:isSearch,
    searchType:searchType,
    searchTerm:searchTerm
}

//console.log("SCROLL-VIEWPORT-INFORMATIONS:",viewportScrollInformations);

var browserLanguage = detectBrowserLanguage();

var viewPort: Viewport;

Vue.config.ignoredElements=['style'];

if (isIndex) {
    
    viewPort = new IndexViewport(language ? lang : Language.DE, viewportScrollInformations);
    viewPort.viewportModus = ViewPortModus.STARTPAGE;
    
    new Vue({ 
        el: '#main-container',
        data: function () {
            return {
                browserLanguage:browserLanguage,
                viewportLink:viewportLink,
                currentUrl: window.location,
                viewport: viewPort,
                navData: [],
                sections: [],
                prodStruct:{},
                homeHREF:'',
                //isTabGruppedActiv:true,
                activTab:'GROUPED'   // 'GROUPED' ALPHABETICAL, SERVICEPACK
               /* homeHREF:viewPort.viewportLanguage===Language.DE?Config.CONTEXT_PATH+'/'+INDEX_PAGE_DE
                :Config.CONTEXT_PATH+'/'+INDEX_PAGE_EN */
            }
        },
        watch:{
            isTabGruppedActiv(newv,oldval){
               // console.log('Into Watch TabChanged on First', newv);
               // console.log('Into Watch TabChanged on First', oldval);


            },

            currentUrl:function(news , alt){
             //   console.log('Into Watch TabChanged');
                
             //   this.$set(this.$data, 'isTabGruppedActiv', !window.location.hash.substr(1).toLowerCase().startsWith('alphabe'))
            }
        },
        components: {
            'lang-dropdown': LangDropdown,
             'search': SearchComponent,
            'fuj-message': Message,
            'fuj-modal': Modal,
            'fuj-tabs': Tabs,
            'fuj-tab': Tab,
            'product-section': ProductSectionComponent,
            'product-alphabetical': ProductAlphabeticalComponent,
            'servicepack-section':ProductServicePackComponent
        },
        methods: {
            getAlphabeticalProds: function () {
           //  console.log('OH THIS SHOULDNTss HAPPEN',this.prodStruct.alphabeticalProducts );
            //    console.log('OH THIS SHOULDNTss HAPPEN PULLO',this.prodStruct );
            //    console.log('OH THIS SHOULDNTss HAPPEN PULLO-SERVICEPACK',this.prodStruct.servicePacks);

                if(this.prodStruct.alphabeticalProducts){
                 //   console.log('OH THIS SHOULDNT HAPPEN',this.prodStruct.alphabeticalProducts );

                    return Object.entries(this.prodStruct.alphabeticalProducts);
                }
 
                return {};
             },
             getServicePackProds: function () {
                // console.dir("SERVICE PACK PACK : ",this.prodStruct.servicePack);
                // console.dir("SERVICE PACK PACK-PROD : ",this.prodStruct);
                // console.dir("SERVICE PACK PACK-Alpha : ",this.prodStruct.alphabeticalProducts);
                
                 if(this.prodStruct.servicePacks){
                  //  console.dir("SERVICE PACK PACK- ENTER-IF : ",this.prodStruct.alphabeticalProducts);
                     return this.prodStruct.servicePacks; //Object.entries(this.prodStruct.servicePacks);
                 }

              // console.dir("SERVICE PACK PACK EMPTY ARRAY : ",this.prodStruct.servicePacks);

                 return [];
              },
             getHomeHREF: function(){

             }
        },
        computed: {
            
        },
        mounted(){
            /*
            var thisview=this;
            window.addEventListener('hashchange',function(e){
                console.log('YEAHHHH ENDLICH', e);  
                thisview.$set(thisview.$data, 'isTabGruppedActiv', !window.location.hash.substr(1).toLowerCase().startsWith('alphabe'))
                thisview.$forceUpdate();          
              });
              */
        },
 
        created() {
           /* console.log("########ENTER CREATE MAIN")
           'GROUPED' ALPHABETICAL, SERVICEPACK
           Produktgruppen/ProductGroups
           Alphabetisch/Alphabetical
           Servicepacks/Servicepacks  
          */

          let selTab:string='GROUPED';

          let tabHash:string =  window.location.hash.substr(1).toLowerCase();
          switch (tabHash) {
              case 'alphabetisch':
              case 'alphabetical':
                  selTab = 'ALPHABETICAL'; 
                  break;
              case 'service-packs':
              case 'service-packs':
                  selTab = 'SERVICEPACK';
                  break;
              case 'softbooks':
                  selTab = 'DOWNLOAD';
                  break;
          
              default:
                  selTab = 'GROUPED';
                  break;
          }
             

            this.$set(this.$data, 'activTab',selTab);
         // this.$set(this.$data, 'isTabGruppedActiv', !window.location.hash.substr(1).toLowerCase().startsWith('alphabe'));

           return viewPort.utilserv.loadDatas(language)
                .then(result => {
                    this.$set(this.$data, 'prodStruct', (viewPort.utilserv.productStructur)?
                    viewPort.utilserv.productStructur:{lang:language, productAreas:[],alphabeticalProducts:[],products:[] });

                    this.$set(this.$data, 'homeHREF',viewPort.viewportLanguage===Language.DE?contextPath+'/'+INDEX_PAGE_DE
                    :contextPath+'/'+INDEX_PAGE_EN);
                })
                .catch(xhr => {
                   // console.log(xhr);
                    throw new Error('Error initializing Index-Viewport: ' + xhr);
                });

        }, //End Create


        beforeCreate(){
            moveInDocumentStyles();
        }
        ,

    });
}
else if(isSearch){
     
    var searchViewPortInformation = {vpInfo:viewportScrollInformations};


    new Vue({ 
        el: '#main-container',
        data: function () {
            return {
                viewport: searchViewPortInformation,
                searchResultStruct:{},
                homeHREF:''
            }
        },
        components: {
            /*
            'lang-dropdown': LangDropdown,
             'search': SearchComponent,
            'fuj-message': Message,
            'fuj-modal': Modal,
            'fuj-tabs': Tabs,
            'fuj-tab': Tab,
            'product-section': ProductSectionComponent,
            'product-alphabetical': ProductAlphabeticalComponent
            */
        },
        methods: {
             getHomeHREF: function(){

             }
        },
        computed: {
            
        },
 
        created() {
           // console.log("########ENTER CREATE SEARCH VIEWPORT")
            this.$set(this.$data, 'homeHREF',language==='DE'?contextPath+'/'+INDEX_PAGE_DE
            :contextPath+'/'+INDEX_PAGE_EN);

            return loadsearchData(searchTerm,language)
            .done(response => {
             // console.log('Gone well fetching searchData for..',searchTerm);
             // console.dir(response);
              this.$set(this.$data, 'searchResultStruct',response);
             
            })
            .fail(xhr => {
              throw new Error('An error occured while getting searchResults for searchTerm:'+searchTerm+"  " + xhr);
            })
            .catch(xhr => {
               // console.log(xhr);
                throw new Error('Error initializing Index-Viewport: ' + xhr);
            });

        }, //End Create


        beforeCreate(){
            moveInDocumentStyles();
        }
        ,

    });
}
else if(isEmptyView){
    viewPort = new EmptyViewport(language ? lang : Language.DE, viewportScrollInformations);
    viewPort.viewportModus = ViewPortModus.STARTPAGE;

    new Vue({ 
        el: '#main-container',
        data: function () {
            return {
                viewport:viewPort,
                homeHREF:''
            }
        },
        components: {
           
        },
        methods: {
             getHomeHREF: function(){

             }
        },
        computed: {
            
        },
 
        created() {
            //console.log("#########ENTER CREATE EMPTY VIEWPORT")
            this.$set(this.$data, 'homeHREF',language==='DE'?contextPath+'/'+INDEX_PAGE_DE
            :contextPath+'/'+INDEX_PAGE_EN);

        }, //End Create


        beforeCreate(){
            moveInDocumentStyles();
        }
        ,
    });
}
else {
//console.log('URL-TO-CALL: ', process.env.VUE_APP_BASE_URL+'/rest/fjadmintools/1.0/manuals/getStructure?language=de');

    $.ajax({ 
        url: process.env.VUE_APP_BASE_URL+'/rest/fjadmintools/1.0/manuals/getStructure?language='+language,
        method: "GET"
      }).
      then((response)=>{
        return getSpaceContentProperties(spaceKey,viewportScrollInformations);
      })
        .then(function(result){
            viewPort = new ProductViewport(<SpaceProperty>result.value,viewportScrollInformations);
            viewPort.viewportModus = ViewPortModus.PRODUCT_SECTION;
            return viewPort;
        })
        .then(function(resultx){
           return viewPort.utilserv.loadProductVersionsDatas(<ProductViewport>viewPort);
        })
        .then(function(resulty){
            viewPort.utilserv.productStructur = resulty;
            populateProductSpace(<ProductViewport>viewPort);
            return resulty;
        })
        .then(
        (viewport) => {
        
            new Vue({
                el: '#main-container',
                data: function () {
                    return {
                        viewport: viewPort,
                        homeHREF:viewPort.viewportLanguage===Language.DE?contextPath+'/'+INDEX_PAGE_DE
                        :contextPath+'/'+INDEX_PAGE_EN
                    }
                },
                components: {
                    'lang-dropdown': LangDropdown,
                    'search': SearchComponent,
                    'version-select': VersionSelectDropdown,
                    'tree-item': TreeItem,
                    'root-el':RootEl,
                    'multipane':Multipane,
                    'multipane-resizer':MultipaneResizer
                },
                methods: {
                },
                computed: {

                },

                beforeCreate(){
                    moveInDocumentStyles();
                }

            });
        }
        )
        .fail(err => {
  //          console.error('An errfffor occured while retrieving Content Properties: ', err);
            viewPort = new ProductViewport(
                <SpaceProperty>{prodId:'',prod: prodName,lang:lang,productPackage:false},
                viewportScrollInformations);
        });
}


/*Setting CSS rules  */

$(document).ready(function(){
//'table#handbooks-overview'
$('table.handbooks-overview').addClass('table').addClass('table-striped table-bordered bs2-table-padding');
$('table.sp-products-overview').addClass('table').addClass('table-striped table-bordered bs2-table-padding');
//$('td.pdf-column a').html('<i class="fa fa-2x fa-file-pdf-o" aria-hidden="true"></i>');
$('td.pdf-column.fj-mediatype-text a').html('<i class="fa fa-2x fa-file-text-o" aria-hidden="true"></i>');
$('td.pdf-column.fj-mediatype-pdf a').html('<i class="fa fa-2x fa-file-pdf-o" aria-hidden="true"></i>');
$('td.pdf-column.fj-mediatype-zip a').html('<i class="fa fa-2x fa-file-zip-o" aria-hidden="true"></i>');
$('td.pdf-column.fj-mediatype-iso a').html('<i class="fa fa-2x fa-download" aria-hidden="true"></i>');
$('td.html-column.nohtml-content').html('<i class="fa fa-2x fa fa-html5" aria-hidden="true"></i>').css('opacity',0.7).css('pointer-events','none').css('color','gray');
$('td.html-column.html-content a').html('<i class="fa fa-2x fa fa-html5" aria-hidden="true"></i>');
$('td.html-column.external-html-content a').html('<i class="fa fa-2x fa fa-external-link" aria-hidden="true"></i>').attr('target','_blank');
  

/*  CORRECT CONFLUENCE TABLE PROBLEME AND ACTIVATE TABLE SORTING */

$($('th').parent().parent()).each(function(){
	if ($(this).is('tbody')) {
		var th = $(this).find('th')
		if (th.length != $(this).find('tr:last-child td').length) {
			return
		}
		var tr = th.parent()
		tr.parents('table').prepend('<thead></thead>')
		tr.parents('table').find('thead').append(tr.detach())
	}
});

/*
    $(window).on('hashchange', function () {
      location.reload();
    });
*/
    //manually tiggering it if we have hash part in URL
  /*  if (window.location.hash) {
        $(window).trigger('hashchange')
    }

*/

});

 